<template>
    <div>
        <div v-if="str" class="app-container">
            <div class="app-title">
                {{ type ? (str[type.label] ? str[type.label] : type.label) : str['contents'] }}
            </div>
            <div v-if="data.length" class="app-cards">
                <div v-for="item in data" :key="item.value">
                    <v-card class="cursor-hover" @click="openItem(item)">
                        <v-img
                            :src="item.image"
                            class="align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="200px"
                            cover
                        >
                            <v-card-title>
                                <div>
                                    {{ str[item.label] ? str[item.label] : item.label }}
                                </div>
                                <img
                                    v-if="alerts && alerts.indexOf(item.value) > -1"
                                    src="../assets/images/icon_new.svg"
                                    class="app-cards-float-icon"
                                />
                            </v-card-title>
                        </v-img>
                    </v-card>
                </div>
            </div>
            <div class="app-footer flex-center">
                <v-btn @click="back()" class="default">
                    {{ str['back'] }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from '../services/Utils'

export default {
    data() {
        const type = this.$route.query && this.$route.query.type_label ? {
            label: this.$route.query.type_label,
            value: parseInt(this.$route.query.type_value),
        } : null
        const alerts = window.appCache && window.appCache.alertsNewContents && type ? window.appCache.alertsNewContents.filter(function (a) {
            return a.type === type.value
        }) : null
        return {
            str: Utils.getStrings(),
            type: type,
            data: [],
            alerts: alerts ? alerts.map(a => a.sub_type) : null,
        }
    },
    beforeMount: function () {
        this.main()
    },
    methods: {
        main: function () {
            this.getSubTypes()
        },
        getSubTypes: function () {
            const subTypes = Utils.getContentType()
            if (subTypes && this.type && subTypes[this.type.value] && subTypes[this.type.value].sub_types && subTypes[this.type.value].sub_types.length) {
                this.data = subTypes[this.type.value].sub_types
            } else {
                delete window.cache
                this.$router.replace({ path: '/contents' })
            }
        },
        openItem: function (item) {
            const queryParams = { ...this.$route.query }
            queryParams.sub_type_label = item ? item.label : null
            queryParams.sub_type_value = item ? item.value : null
            delete window.cache
            this.$router.push({
                path: '/contents',
                query: queryParams
            })
        },
        back: function () {
            this.$router.back()
        },
        onBackEvent: function () {
            const self = this
            this.$root.$on('app-back', function () {
                self.back()
            })
        },
        offBackEvent: function () {
            this.$root.$off('app-back')
        },
    },
    mounted () {
        this.onBackEvent()
    },
    beforeDestroy () {
      this.offBackEvent()
    }
}
</script>